import { FaroTextButton } from "@components/common/faro-text-button";
import { useAuthContext } from "@context-providers/auth/auth-context";
import { neutral } from "@flat-ui";
import { DEFAULT_INPUT_FONT_SIZE } from "@styles/common-styles";
import { UserMenuEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";

/** The logout button for mobile layout in account settings */
export function LogoutButtonMobile(): JSX.Element {
  const { trackEvent } = useTrackEvent();
  const { logout } = useAuthContext();
  function onLogoutClick(): void {
    trackEvent({
      name: UserMenuEvents.logOut,
      props: {
        from: "account-settings",
      },
    });

    void logout();
  }

  return (
    <FaroTextButton
      sx={{
        color: neutral[800],
        fontSize: DEFAULT_INPUT_FONT_SIZE,
        width: "100%",
        justifyContent: "flex-start",
        p: "8px",
        mt: "4px",
      }}
      onClick={onLogoutClick}
    >
      Log out
    </FaroTextButton>
  );
}
